<template>
  <b-modal
    id="activate-advertiser-modal"
    :modal-class="'default-modal'"
    :hide-footer="true"
  >
  <AlertWraper
  :content="content"
  :type="content_type"
  />
    <div class="text-center mt-3">
      <div class="mb-4">
        <i class="fa fa-warning font-size-large text-warning"></i>
      </div>
      <div class="text-center">
        <h2 class="highlighted-color1">
          <span>{{ $t('activate_advertiser') }}</span>
        </h2>
      </div>
      <p v-html="$t('want_to_activate_advertiser', {name: this.advertiser ? this.advertiser.name : ''})"></p>
      <p v-html="$t('info_activate_advertiser')"></p>
      <div class="mt-3">
        <!-- MESSAGES -->
        <div
          class="mb-2 alert-message-card text-color2 font-size-small px-3 py-2"
          v-if="loader"
        >
          <p
            class="mb-0"
          >
            {{ $t('this_action_may_take_a_few_minutes') }}
          </p>
        </div> <!-- END MESSAGES -->
        <Button
          type="button"
          class="btn btn-color10"
          @click="submit"
          :loading="loader"
        >
          {{ $t('activate_advertiser') }}
        </Button>
      </div>
    </div>
  </b-modal>
</template>

<script>

import AdvertisersService from '@/modules/advertisers/services/advertisers-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'

export default {
  name: 'ActivateAdvertiserModal',
  props: ['advertiser'],
  components: {
    AlertWraper,
    Button
  },
  data () {
    return {
      loader: false,
      content: null,
      content_type: 'error'
    }
  },
  methods: {
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      try {
        await AdvertisersService.activateAdvertiser(this.advertiser.id)
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('advertiser_successfully_activated')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$bvModal.hide('activate-advertiser-modal')
        if (this.advertiser) this.$emit('advertiser-activated', this.advertiser)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
